import request from '@/utils/request'
import { getCourseApiUrl } from './config'
type dataType = any
export default {
    // //九方热榜
    // hotList(data: dataType): Promise<{
    //     response?: Response
    // }> {
    //     return request({
    //         url: apiUrl + '/rjhy-finance/api/1/hot/stock/list',
    //         method: 'get',
    //         params: data,
    //         headers: {
    //             appCode: 'com.rjhy.uranus',
    //         },
    //         sign: true
    //     })
    // },
    // //分时排名
    // hotMin(data: dataType): Promise<{
    //     response?: Response
    // }> {
    //     return request({
    //         url: apiUrl + '/rjhy-finance/api/1/stock/hot/min10',
    //         method: 'get',
    //         params: data,
    //         headers: {
    //             appCode: 'com.rjhy.uranus',
    //         },
    //         sign: true
    //     })
    // },
    // //历史排名
    // hotHis(data: dataType): Promise<{
    //     response?: Response
    // }> {
    //     return request({
    //         url: apiUrl + '/rjhy-finance/api/1/stock/hot/his',
    //         method: 'get',
    //         params: data,
    //         headers: {
    //             appCode: 'com.rjhy.uranus',
    //         },
    //         sign: true
    //     })
    // },
    // //概念榜、行业榜
    // hotPList(data: dataType, headers?: any): Promise<{
    //     response?: Response
    // }> {
    //     return request({
    //         url: apiUrl + '/rjhy-quote-sector/api/2/hot/plate/list',
    //         method: 'get',
    //         params: data,
    //         headers: {
    //             appCode: 'com.rjhy.uranus',
    //             ...headers
    //         },
    //         sign: true
    //     })
    // },
    //学堂首页
    schoolHome(data: dataType): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-edu-uranus/api/1/school/home',
            method: 'post',
            data: data,
            headers: {
                appCode: 'com.rjhy.uranus',
            },
            sign: true
        })
    },
    //投资学堂-全部课程导航栏
    schoolCourseAllNav(): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-edu-uranus/api/1/school/course/all/nav',
            method: 'get',
            headers: {
                appCode: 'com.rjhy.uranus',
            },
            sign: true
        })
    },
    //投资学堂-全部课程分页查询
    schoolCourseAllPage(data: dataType, headers?: any): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-edu-uranus/api/1/school/course/all/page',
            method: 'post',
            data: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                ...headers
            },
            sign: true
        })
    },
    //投资学堂-课程和课时详情
    schoolCourseLessonDetail(data: dataType, headers?: any): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-edu-uranus/api/1/subscribe/course/detail',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                username: headers?.username,
                ...headers
            },
            sign: true
        })
    },
    //投资学堂-文章课文章分页查询
    schoolCourseArticlePage(data: dataType, headers?: any): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-edu-uranus/api/1/school/course/article/page',
            method: 'post',
            data: data,
            headers: {
                'Content-Type': 'application/json',
                username: headers?.username,
                ...headers
            },
            sign: true
        })
    },
    //文章详情
    newsContent(data: dataType, headers?: any): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-news/api/1/9fztgw/news/content',
            method: 'get',
            params: data,
            headers: {
                appCode: 'com.rjhy.uranus',
                ...headers
            },
            sign: true
        })
    },
    //综合搜索
    stockEntrance(data: dataType, headers?: any): Promise<{
        response?: Response
    }> {
        return request({
            url: getCourseApiUrl() + '/rjhy-quote-search/api/1/stock/entrance',
            method: 'get',
            params: data,
            headers: {
                ...headers
            },
            sign: true
        })
    }
}

// 查询播放地址(仅限APP使用)
export function getVideoPlayInfoList(data: dataType, headers?: any): Promise<{
    response?: Response
}> {
    return request({
        url: getCourseApiUrl() + '/rjhy-torrent-video/api/1/video/play/info/list',
        method: 'post',
        data: data,
        headers: {
            'Content-Type': 'application/json',
            username: headers?.username,
            ...headers
        },
        sign: true
    })
}
